export const EMPTY_REPORT_ADD_MODAL = {
  isOpen: false,
  step: 'library',
  context: null,
  submitting: false,
  library: {
    loading: false,
    refreshing: false,
    error: null,
    reports: [],
    query: '',
    reportTypeFilter: '',
  },
};

export const REPORT_LIBRARY_TYPE_FILTERS = [
  { id: '', label: 'All' },
  { id: 'TABULAR', label: 'Table' },
  { id: 'CHART', label: 'Chart' },
  { id: 'SUMMARY', label: 'Summary' },
  { id: 'KPI', label: 'KPI' },
];
